/* ============================================================
   VIENTRE DE PAPEL – COUPON (Estándar / Premium / Personalizado)
   - Varianti Shopify automatiche (prese dal DOM)
   - Cambio prezzo in tempo reale
   - Campi dinamici per quantità
   - Descripción dinámica
   - NIENTE badge
   - Niente proprietà visibili nel carrello
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".vp-coupon-wrapper");
  if (!wrapper) return;

  const botones = wrapper.querySelectorAll(".vp-boton-tipo");
  const detalles = wrapper.querySelector("#vp-detalles-cupon");
  const descZone = document.querySelector("#vp-descripcion-cupon");
  const priceEl = document.querySelector(".price-item--regular");
  const originalCurrency = priceEl?.dataset.priceCurrency || "EUR";

  function parseVariantPrice(value) {
    return parseFloat(String(value || "").trim().replace(",", "."));
  }

  /* ============================================================
     1) LEGGIAMO LE VARIANTI REALI DAL DOM
     ============================================================ */

  const VP_COUPON_VARIANTS = {};

  document.querySelectorAll("[data-product-variant]").forEach(el => {
    const option = el.dataset.variantOption?.toLowerCase().trim();
    const id = Number(el.dataset.variantId);
    const price = parseVariantPrice(el.dataset.variantPrice);

    if (!option || !id) return;

    let key = option.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    if (key.includes("personal")) key = "personalizado";
    else if (key.includes("premium")) key = "premium";
    else key = "estandar";

    VP_COUPON_VARIANTS[key] = { id, price };
  });

  console.log("=== Varianti trovate ===", VP_COUPON_VARIANTS);

  /* ============================================================
     FUNZIONI BASE
     ============================================================ */

  function getQtyInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function cantidad() {
    const input = getQtyInput();
    const v = input ? parseInt(input.value, 10) : 1;
    return isNaN(v) || v < 1 ? 1 : v;
  }

  function tipoActivo() {
    const activo = wrapper.querySelector(".vp-boton-tipo.is-active");
    if (!activo) return "estandar";

    let tipo = activo.dataset.tipo.toLowerCase().trim();
    tipo = tipo.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    if (tipo.includes("personal")) return "personalizado";
    if (tipo.includes("premium")) return "premium";
    return "estandar";
  }

  function getVariantInput() {
    return document.querySelector("product-form form input[name='id']");
  }

  /* ============================================================
     CAMBIO VARIANTE + PREZZO
     ============================================================ */
  function updateVariantAndPrice() {
    const idInput = getVariantInput();
    const tipo = tipoActivo();
    const varData = VP_COUPON_VARIANTS[tipo];

    if (!varData || !idInput) return;

    idInput.value = varData.id;

    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* ============================================================
     DESCRIPCIÓN DINÁMICA
     ============================================================ */

  function renderDescripcionCupon() {
    if (!descZone) return;

    const tipo = tipoActivo();
    let html = '';
    /* let html = `
      <div class="vp-descripcion">
        <p>Pack de vales prácticos pensados para aliviar a mamá durante el posparto,
        liberándole tiempo y energía para dedicarse a lo más importante: su bebé.</p>
      </div>
    `; */

    if (tipo === "estandar") {
      html += `
        <div class="vp-descripcion-extra">
          <p><strong>Pack de 6 vales prácticos para ayudar a mamá, 
          liberándole tiempo para lo único importante: su bebé.</strong></p>
          <p>Este pack incluye los vales:</p>
          <ul>
            <li>Vale por poner la lavadora o lavar los platos</li>
            <li>Vale por ir a hacer la compra</li>
            <li>Vale por una tanda de tuppers</li>
            <li>Vale por ayudarte con el bebé</li>
            <li>Vale por un gran abrazo</li>
            <li>Vale por una llamada a cualquier hora</li>
          </ul>
        </div>`;
    }

    if (tipo === "premium") {
      html += `
        <div class="vp-descripcion-extra">
          <p><strong>Pack de 9 vales prácticos para ayudar a mamá, 
          liberándole tiempo para lo único importante: su bebé.</strong></p>
          <p>Este pack incluye los vales:</p>
          <ul>
            <li>Vale por poner la lavadora o lavar los platos</li>
            <li>Vale por ir a hacer la compra</li>
            <li>Vale por una tanda de tuppers</li>
            <li>Vale por ayudarte con el bebé</li>
            <li>Vale por un gran abrazo</li>
            <li>Vale por una llamada a cualquier hora</li>
            <li>Vale por ayudar con el papeleo del registro / bajas</li>
            <li>Vale por una hora de sueño</li>
            <li>Vale sorpresa, ¡pide lo que quieras!</li>
          </ul>
        </div>`;
    }


    descZone.innerHTML = html;
  }

  /* ============================================================
     RENDER DINÁMICO PACKS
     ============================================================ */

  function render() {
    const tipo = tipoActivo();
    const cant = cantidad();
    let html = "";

    const saved = {};
    detalles.querySelectorAll("select, input").forEach(el => {
      saved[el.name] = el.value;
    });

    for (let i = 1; i <= cant; i++) {
      html += `
        <div class="vp-pack-bloque">
          <h4 class="vp-pack-titulo">Pack de Vales ${i}</h4>
      `;

      if (tipo === "estandar" || tipo === "premium") {
        html += `
          <label class="vp-label-campo">¿Esperas uno o más bebés?</label>
          <select name="properties[Cupón ${i} - Bebés]" 
                  class="vp-select hijos-select" data-pack="${i}">
            <option value="1 bebé">1 bebé</option>
            <option value="Más de 1 bebé">Más de 1 bebé</option>
          </select>
        `;
      }


      html += `</div>`;
    }

    html += `<input type="hidden" name="attributes[_tipo_cupon]" value="${tipo}">`;

    detalles.innerHTML = html;

    detalles.querySelectorAll("select, input").forEach(el => {
      if (saved[el.name]) el.value = saved[el.name];
    });

    detalles.querySelectorAll(".hijos-select").forEach(sel => {
      sel.addEventListener("change", updateHijos);
      updateHijos({ target: sel });
    });

    updateVariantAndPrice();
    renderDescripcionCupon();
  }

  function updateHijos(e) {
    const select = e.target;
    const pack = select.dataset.pack;
    const zone = detalles.querySelector(`[data-pack-hijos="${pack}"]`);
    if (!zone) return;

    if (select.value === "1 bebé") {
      zone.innerHTML = `
        <label>Nombre del bebé</label>
        <input type="text" name="properties[Cupón ${pack} - Bebé 1]" class="vp-input">
      `;
    } else {
      zone.innerHTML = `
        <label>Nombre del bebé 1</label>
        <input type="text" name="properties[Cupón ${pack} - Bebé 1]" class="vp-input"><br>

        <label>Nombre del bebé 2</label>
        <input type="text" name="properties[Cupón ${pack} - Bebé 2]" class="vp-input">
      `;
    }
  }

  /* ============================================================
     EVENTI
     ============================================================ */

  botones.forEach(btn => {
    btn.addEventListener("click", () => {
      botones.forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      render();
    });
  });

  document.body.addEventListener("input", e => {
    if (e.target.matches('input[name="quantity"]')) render();
  });

  document.body.addEventListener("click", e => {
    if (e.target.closest(".quantity__button")) setTimeout(render, 50);
  });

  /* INIT */
  render();
});
